module.exports = __webpack_public_path__ + "static/media/3.cd445ab3.jpg";